import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export type PreviewDuration = '15min' | '30min' | '60min' | '5h' | '12h' | '24h' | 'always';

export const PREVIEW_DURATION_LABELS: Record<PreviewDuration, string> = {
    '15min': '15 minutos',
    '30min': '30 minutos',
    '60min': '1 hora',
    '5h': '5 horas',
    '12h': '12 horas',
    '24h': '24 horas',
    'always': 'Sempre disponível'
};

export interface GeneratePreviewResponse {
    token: string;
    urlSlug: string;
    expiresAt: string | null;
    duration: PreviewDuration;
    previewPagesLimit: number | null;
}

export interface ApostilaPreviewData {
    title: string;
    pages: Array<{ id: string; title: string; content: string; order: number }>;
    quizzes: Record<string, any>;
    deckName: string;
    subdeckName: string;
    expiresAt: string;
    deckId: string;
    subdeckId: string;
    previewPagesLimit: number | null;
    // Slug do RyanProduct que vende acesso a este deck/subdeck, resolvido no
    // backend (RyanSpace.subdeckRefs -> RyanProduct.spaceIds). null quando não
    // há produto público vendendo este conteúdo — nesse caso os CTAs de
    // "assinar" caem no fallback genérico (/login).
    checkoutSlug: string | null;
    // Para o modal de fim da prévia (mesmo "Quase lá" da RyanFieldPage):
    // link de compra configurado no campo, nome do produto e WhatsApp
    purchaseUrl?: string;
    productTitle?: string;
    whatsappNumber?: string;
}

export interface ActivePreviewToken {
    _id: string;
    urlSlug: string;
    expiresAt: string | null;
    previewPagesLimit: number | null;
    createdAt: string;
}

const apostilaPreviewService = {
    async generateToken(
        deckId: string,
        subdeckId: string,
        duration: PreviewDuration,
        previewPagesLimit: number | null,
        authToken: string
    ): Promise<GeneratePreviewResponse> {
        const res = await axios.post(
            `${API_BASE}/api/apostila-previa/generate/${deckId}/${subdeckId}`,
            { duration, previewPagesLimit },
            { headers: { Authorization: `Bearer ${authToken}` } }
        );
        return res.data;
    },

    async listActiveTokens(
        deckId: string,
        subdeckId: string,
        authToken: string
    ): Promise<ActivePreviewToken[]> {
        const res = await axios.get(
            `${API_BASE}/api/apostila-previa/list/${deckId}/${subdeckId}`,
            { headers: { Authorization: `Bearer ${authToken}` } }
        );
        return res.data;
    },

    async revokeToken(urlSlug: string, authToken: string): Promise<void> {
        await axios.delete(
            `${API_BASE}/api/apostila-previa/${urlSlug}`,
            { headers: { Authorization: `Bearer ${authToken}` } }
        );
    },

    async readBySlug(urlSlug: string): Promise<ApostilaPreviewData> {
        const res = await axios.get(`${API_BASE}/api/apostila-previa/read/${urlSlug}`);
        return res.data;
    }
};

export default apostilaPreviewService;
